import type { LayerRaw } from '@tsyl/karonte/lib/types/layers'

import { getSvgSquare } from '@/utils/SvgTools.ts'
import { getTimeExtent, prior1Date, prior30Date, prior7Date } from '@/utils/timeTools'

export const BurnedAreasViirs1Day = {
  id: 'BurntAreasViirsEffis1',
  type: 'WMS',
  url: 'https://maps.effis.emergency.copernicus.eu/gwis?service=WMS',
  title: {
    'en-US': 'Burned Areas (VIIRS) 1 Days',
    'pt-BR': 'Áreas Queimadas (VIIRS) 1 Dias',
    'es-ES': 'Zonas quemadas (VIIRS) 1 Días',
    'fr-FR': 'Zones brûlées (VIIRS) 1 Jours'
  },
  zindex: 1,
  active: true,
  activeTarget: 'visibility',
  enabled: false,
  customProperties: { group: 'burnedAreas:viirs' },
  opacity: 0.75,
  legend: {
    title: 'n/a'
  },
  sublayers: [
    {
      id: 'nrt.ba',
      visible: true,
      legend: {
        title: {
          'en-US': 'Burned Areas (VIIRS)',
          'pt-BR': 'Áreas Queimadas (VIIRS)',
          'es-ES': 'Zonas quemadas (VIIRS)',
          'fr-FR': 'Zones brûlées (VIIRS)'
        },
        items: [
          {
            svg: getSvgSquare('#c91809', '#4a2727'),
            text: {
              'en-US': 'Burned Areas (VIIRS)',
              'pt-BR': 'Áreas Queimadas (VIIRS)',
              'es-ES': 'Zonas quemadas (VIIRS)',
              'fr-FR': 'Zones brûlées (VIIRS)'
            }
          }
        ]
      }
    }
  ],
  extraArcgisParameter: {
    customLayerParameters: {
      time: getTimeExtent(prior1Date)
    }
  }
} as LayerRaw

export const BurnedAreasViirs7Days = {
  id: 'BurntAreasViirsEffis7',
  type: 'WMS',
  url: 'https://maps.effis.emergency.copernicus.eu/gwis?service=WMS',
  title: {
    'en-US': 'Burned Areas (VIIRS) 7 Days',
    'pt-BR': 'Áreas Queimadas (VIIRS) 7 Dias',
    'es-ES': 'Zonas quemadas (VIIRS) 7 Días',
    'fr-FR': 'Zones brûlées (VIIRS) 7 Jours'
  },
  zindex: 1,
  active: true,
  activeTarget: 'visibility',
  enabled: false,
  customProperties: { group: 'burnedAreas:viirs' },
  opacity: 0.75,
  legend: {
    title: 'n/a'
  },
  sublayers: [
    {
      id: 'nrt.ba',
      visible: true,
      legend: {
        title: {
          'en-US': 'Burned Areas (VIIRS)',
          'pt-BR': 'Áreas Queimadas (VIIRS)',
          'es-ES': 'Zonas quemadas (VIIRS)',
          'fr-FR': 'Zones brûlées (VIIRS)'
        },
        items: [
          {
            svg: getSvgSquare('#c91809', '#4a2727'),
            text: {
              'en-US': 'Burned Areas (VIIRS)',
              'pt-BR': 'Áreas Queimadas (VIIRS)',
              'es-ES': 'Zonas quemadas (VIIRS)',
              'fr-FR': 'Zones brûlées (VIIRS)'
            }
          }
        ]
      }
    }
  ],
  extraArcgisParameter: {
    customLayerParameters: {
      time: getTimeExtent(prior7Date)
    }
  }
} as LayerRaw

export const BurnedAreasViirs30Days = {
  id: 'BurntAreasViirsEffis30',
  type: 'WMS',
  url: 'https://maps.effis.emergency.copernicus.eu/gwis?service=WMS',
  title: {
    'en-US': 'Burned Areas (VIIRS) 30 Days',
    'pt-BR': 'Áreas Queimadas (VIIRS) 30 Dias',
    'es-ES': 'Zonas quemadas (VIIRS) 30 Días',
    'fr-FR': 'Zones brûlées (VIIRS) 30 Jours'
  },
  zindex: 1,
  active: true,
  activeTarget: 'visibility',
  enabled: false,
  customProperties: { group: 'burnedAreas:viirs' },
  opacity: 0.75,
  legend: {
    title: 'n/a'
  },
  sublayers: [
    {
      id: 'nrt.ba',
      visible: true,
      legend: {
        title: {
          'en-US': 'Burned Areas (VIIRS)',
          'pt-BR': 'Áreas Queimadas (VIIRS)',
          'es-ES': 'Zonas quemadas (VIIRS)',
          'fr-FR': 'Zones brûlées (VIIRS)'
        },
        items: [
          {
            svg: getSvgSquare('#c91809', '#4a2727'),
            text: {
              'en-US': 'Burned Areas (VIIRS)',
              'pt-BR': 'Áreas Queimadas (VIIRS)',
              'es-ES': 'Zonas quemadas (VIIRS)',
              'fr-FR': 'Zones brûlées (VIIRS)'
            }
          }
        ]
      }
    }
  ],
  extraArcgisParameter: {
    customLayerParameters: {
      time: getTimeExtent(prior30Date)
    }
  }
} as LayerRaw
